import i18n from "@/i18n"

export const useSyncDraftsColumns = () => {
  const columns = [
    {
      slots: { title: "imagesTitle" },
      scopedSlots: { customRender: "images" },
      width: "66px",
      dataIndex: "images"
    },
    {
      title: i18n.t("synchronization.table_titles.product_name"),
      dataIndex: "name",
      scopedSlots: { customRender: "name" },
      sorter: true
    },
    {
      title: i18n.t("synchronization.table_titles.brand"),
      width: "120px",
      dataIndex: "brand"
    },
    {
      title: i18n.t("synchronization.table_titles.quantity"),
      width: "120px",
      dataIndex: "quantity",
      sorter: true,
      scopedSlots: { customRender: "quantity" }
    },
    {
      title: i18n.t("synchronization.table_titles.price"),
      width: "120px",
      dataIndex: "price",
      sorter: true,
      scopedSlots: { customRender: "price" }
    },
    {
      title: i18n.t("synchronization.table_titles.status"),
      width: "250px",
      dataIndex: "is_sells",
      // filters: [
      //   {
      //     text: i18n.t('synchronization.for_sale'),
      //     value: String(true)
      //   },
      //   {
      //     text: i18n.t('synchronization.not_for_sale'),
      //     value: String(false)
      //   }
      // ],
      filterMultiple: false,
      scopedSlots: { customRender: "status" }
    }
  ]

  return { columns }
}
